import _slicedToArray from "/Users/kirstymunro/Sites/sme-growth/cigna-frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/tab';
import mediator from './mediator';
export default function () {
  var _location$hash$split = location.hash.split('#'),
      _location$hash$split2 = _slicedToArray(_location$hash$split, 2),
      anchor = _location$hash$split2[1];

  if (anchor) {
    var $this = $("[id*='".concat(anchor, "']"));

    if ($this && $this.hasClass('tab-item')) {
      var mobileSelect = $this.parent().siblings('.tabs-heavy-select').find('select');
      var value = $this.attr('data-tab-label');
      $this.tab('show');
      if (mobileSelect.length) mobileSelect.val(value);
    }
  }

  $(document).on('show.bs.tab', function (e) {
    var $this = $(e.target);
    var $tabsDropdown = $this.parent().siblings('.tabs-heavy-select').find('select');
    $tabsDropdown.trigger('update', e.target);
  });
  $('.tabs-heavy').siblings('.tabs-heavy-select').find('select').on({
    update: function update(e, tab) {
      var relatedTab = tab.dataset.tabLabel;
      $(e.target).val(relatedTab);
    },
    change: function change(e) {
      var $this = $(e.target);
      var tab = $this.val();
      var $el = $this.closest('.tabs-heavy-select').siblings('.tabs-heavy').find("[data-tab-label=".concat(tab, "]"));
      $el.tab('show');
      $this.trigger('update', $el);
    }
  });

  (function ($) {
    $.fn.cignaTabs = function () {
      return this.each(function () {
        var self = this;
        var $self = $(this);
        var defaults = {
          tabs: $self.find('.nav-tabs'),
          leftArrow: $self.siblings('.arrow-left'),
          rightArrow: $self.siblings('.arrow-right')
        };
        var incWidth = 0;
        self.settings = {};

        self.init = function () {
          self.settings = $.extend({}, defaults);
          var _self$settings = self.settings,
              leftArrow = _self$settings.leftArrow,
              rightArrow = _self$settings.rightArrow;
          self.checkArrowHide();
          rightArrow.click(function () {
            self.right($self.find('.nav-tabs .js-tab-target'));
          });
          leftArrow.click(function () {
            self.left($self.find('.nav-tabs .js-tab-target'));
          });
          mediator.on('window:throttledResize', function () {
            return self.resize();
          });
          mediator.trigger('window:throttledResize');
        };

        self.checkArrowHide = function () {
          var _self$settings2 = self.settings,
              leftArrow = _self$settings2.leftArrow,
              rightArrow = _self$settings2.rightArrow,
              tabs = _self$settings2.tabs;
          var tabContainerWidth = $self.parent().width();
          var tabsWidth = tabs.width();

          if (!incWidth || incWidth <= 12) {
            leftArrow.hide();
            incWidth = 0;
          } else {
            leftArrow.show();
          }

          if (tabContainerWidth + incWidth >= tabsWidth) {
            rightArrow.hide();
          } else {
            rightArrow.show();
          }
        };

        self.right = function (currTab) {
          var currTabWidth;

          if (currTab.next().length) {
            currTab.next().addClass('js-tab-target');
            currTab.removeClass('js-tab-target');
            currTabWidth = Math.round(currTab.outerWidth());
          }

          incWidth += currTabWidth;
          $self.animate({
            marginLeft: "-=".concat(currTabWidth)
          });
          self.checkArrowHide();
        };

        self.left = function (currTab) {
          var currTabWidth;

          if (currTab.prev().length) {
            currTab.prev().addClass('js-tab-target');
            currTab.removeClass('js-tab-target');
            currTabWidth = Math.round(currTab.prev().outerWidth());
          }

          incWidth -= currTabWidth;
          $self.animate({
            marginLeft: "+=".concat(currTabWidth)
          });
          self.checkArrowHide();
        };

        self.resize = function () {
          var _self$settings3 = self.settings,
              leftArrow = _self$settings3.leftArrow,
              rightArrow = _self$settings3.rightArrow,
              tabs = _self$settings3.tabs;
          var arrows = $self.siblings('.arrow');
          var tabsWrapper = $self.parent();
          var tabItems = tabs.children();
          var tabsContainerWidth;
          var tabsWidth;

          if (self.tabScrollInactive()) {
            self.addTabScroll();
            tabsWidth = tabs.width();
            tabsContainerWidth = tabsWrapper.width();
            self.removeTabScroll();
          } else {
            tabsWidth = tabs.width();
            tabsContainerWidth = tabsWrapper.width();
          }

          if (tabsContainerWidth >= tabsWidth) {
            arrows.hide();

            if (incWidth) {
              leftArrow.hide();
              $self.find('.js-tab-target').removeClass('js-tab-target');
              tabItems.first().addClass('js-tab-target');
              $self.animate({
                marginLeft: "+=".concat(incWidth)
              });
              incWidth = 0;
            }

            self.removeTabScroll();
          } else {
            self.addTabScroll();
            arrows.show();
            if (!incWidth) leftArrow.hide();
            if (tabsContainerWidth + incWidth >= tabsWidth) rightArrow.hide();
          }
        };

        self.addTabScroll = function () {
          var tabs = self.settings.tabs;
          tabs.removeClass('js-scroll-inactive');
        };

        self.removeTabScroll = function () {
          var tabs = self.settings.tabs;
          tabs.addClass('js-scroll-inactive');
        };

        self.tabScrollInactive = function () {
          var tabs = self.settings.tabs;
          return tabs.hasClass('js-scroll-inactive');
        };

        self.init();
      });
    };
  })(jQuery);

  $('.tabs-container').cignaTabs();
}